/** ヒント候補から除外する機能語 */
export const STOP_WORDS = new Set([
    'the',
    'a',
    'an',
    'is',
    'are',
    'was',
    'were',
    'with',
    'and',
    'of',
    'to',
    'in',
    'on',
    'it',
    'its',
    'at',
    'by',
    'for',
    'or',
    'be',
    'has',
    'have',
    'his',
    'her',
    'their',
    'there',
    'that',
    'this',
]);
export function words(text) {
    return text.trim().split(/\s+/).filter(Boolean);
}
export function stripPunct(w) {
    return w.replace(/^[^A-Za-z0-9']+|[^A-Za-z0-9']+$/g, '');
}
/** 文を単語長の列に変換する（伏せ字表示用）。 */
export function maskOf(text, hintIndex) {
    const ws = words(text);
    const lengths = ws.map((w) => stripPunct(w).length);
    const tails = ws.map((w) => {
        const core = stripPunct(w);
        const idx = w.lastIndexOf(core);
        return idx >= 0 ? w.slice(idx + core.length) : '';
    });
    const mask = { lengths, tails };
    if (hintIndex !== undefined && ws[hintIndex] !== undefined) {
        mask.hint = { wordIndex: hintIndex, word: stripPunct(ws[hintIndex]) };
    }
    return mask;
}
/** ヒント語のインデックスを選ぶ（機能語を除外。rng は 0〜1）。 */
export function pickHintIndex(text, rng = Math.random) {
    const ws = words(text);
    const cands = ws
        .map((w, i) => [stripPunct(w).toLowerCase(), i])
        .filter(([w]) => w.length >= 3 && !STOP_WORDS.has(w))
        .map(([, i]) => i);
    const pool = cands.length ? cands : ws.map((_, i) => i);
    return pool[Math.min(pool.length - 1, Math.floor(rng() * pool.length))] ?? 0;
}
/** 表示用: 伏せ字文字列を組み立てる。 */
export function renderMask(mask, dot = '●') {
    return mask.lengths.map((len, i) => {
        const tail = mask.tails[i] ?? '';
        if (mask.hint && mask.hint.wordIndex === i)
            return { text: mask.hint.word + tail, isHint: true };
        return { text: dot.repeat(Math.max(1, len)) + tail, isHint: false };
    });
}
/** 匿名参加用の表示名（動物 + 2 桁）。名前を入れずに入室したときにサーバーが割り当てる。 */
export const GUEST_ANIMALS = [
    'ネコ',
    'イヌ',
    'ウサギ',
    'パンダ',
    'ペンギン',
    'キツネ',
    'コアラ',
    'ハト',
    'クマ',
    'カメ',
    'リス',
    'タコ',
    'サメ',
    'ゾウ',
    'カエル',
    'フクロウ',
    'ヒツジ',
    'ラッコ',
    'トラ',
    'イルカ',
];
export function randomGuestName(rng = Math.random) {
    const animal = GUEST_ANIMALS[Math.floor(rng() * GUEST_ANIMALS.length)] ?? GUEST_ANIMALS[0];
    const n = 10 + Math.floor(rng() * 90);
    return `${animal}${n}`;
}
/** 表示名を整える: 制御文字を除去し、20 文字に収める。 */
export function sanitizeName(raw) {
    const cleaned = raw
        .replace(/\p{Cc}/gu, '')
        .replace(/\s+/g, ' ')
        .trim();
    return cleaned.slice(0, 20) || 'Player';
}
//# sourceMappingURL=text.js.map